'use es6';

import { Record } from 'immutable';
export default Record({
  roiType: null,
  adSpendCurrencyChoice: null,
  hasConversions: null,
  hasBoostedLeadAd: null,
  hasCreatedLeadAd: null,
  firstConnectedAt: null,
  untrustworthy: null
});